import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "icon", "as"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import TooltipButton from 'components/TooltipButton';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { pxToRem } from 'utils/ui/units';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var StyledButton = styled(TooltipButton).withConfig({
  displayName: "StackedButton__StyledButton",
  componentId: "sc-bcnwht-0"
})(["padding-left:0;padding-right:0;border-radius:", ";"], function (p) {
  return pxToRem(Math.min(p.theme.globals.borderRadius.buttons, 10));
});
function StackedButton(_ref) {
  var children = _ref.children,
    icon = _ref.icon,
    as = _ref.as,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(StyledButton, _objectSpread(_objectSpread({
    variant: "transparent",
    forwardedAs: as
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsx(Icon, {
      name: icon,
      scale: 1.5,
      vAlign: true
    }), /*#__PURE__*/_jsx(Text, {
      size: "xxs",
      display: "block",
      align: "center",
      lineHeight: 1.3,
      children: children
    })]
  }));
}
export default StackedButton;